import PropTypes from "prop-types"

const PaneTitle = ({ className, children }) => {
  return <h1 className={`pane__title ${className ? className : ""}`}>{children}</h1>
}

PaneTitle.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
}

export default PaneTitle
